import dot from 'dot-object'

import type { ECommunityAccess, ICommunity } from '~/entities/container/community/interfaces/community'

import { getContentModelForTemplate } from '~/features-shared/content/api/parser-contents'

import type { SwymResponse } from '~/interfaces/services-dto'

const MOVE_PROPS = [
  ['model_id', 'subject_uri'],
  ['community_intranet_access', 'access'],
  ['uri', 'subject_uri'],
  ['subject6wuri', 'subject_uri'],
  // ['communityUri', '_community.id'],
  // ['communityTitle', '_community.title'],
]

function _communityParser(response: ICommunity) {
  MOVE_PROPS.forEach(([from, to]) => {
    dot.move(from, to, response)
  })

  if (typeof response.access === 'string') {
    switch (response.access) {
      case 'Public':
        response.access = 1
        break
      case 'Private':
        response.access = 0
        break
      case 'Secret':
        response.access = 4
        break

      default:
        response.access = Number.parseInt(response.access) as ECommunityAccess
        break
    }

    // to int
    ([
      'access',
      'extranet_access',
      'tenant_user_status',
      'user_access',
      'stats_min_acl',
      'post_min_acl',
      'media_min_acl',
      'ideation_min_acl',
      'qna_min_acl',
      'wiki_min_acl',
      'wedo_min_acl',
      'survey_min_acl',
      'conference_min_acl',
    ] as Partial<keyof ICommunity>[])
      .forEach((key) => {
        if (key in response)
          // @ts-expect-error ts can't infer that key is typeof number
          response[key] = Number.parseInt(response[key] as string, 10)
      })
  }

  // response.default_type_for_creation does not match IContentModel, this is why it needs to be converted to it
  if (response.default_type_for_creation)
    response.default_type_for_creation = getContentModelForTemplate(response.default_type_for_creation.toLowerCase())

  return response
}

export function communityParser(response: SwymResponse<ICommunity>): SwymResponse<ICommunity> {
  response.result = _communityParser(response.result)

  return response
}

export function communitiesParser(response: SwymResponse<ICommunity[]>) {
  response.result = response.result.map(_communityParser)

  return response
}
